import { FormGroup, List } from '@ksyos/design-system';
import { ListItem } from '@frontend/components/elements/List/List';

export function FormGroupBulletList({ items, label }: Readonly<{ items: string[]; label: string }>) {
    return (
        <FormGroup label={label}>
            <List styleType="bullet">
                {items.map((item) => (
                    <ListItem key={item}>{item}</ListItem>
                ))}
            </List>
        </FormGroup>
    );
}
